module.exports = __webpack_public_path__ + "static/media/Kopie von RR-LOGO.c0ccd178.png";